/* ============================================================
   PER DIEM — THEME.JS
   ============================================================ */

(function () {
  'use strict';

  /* ── CART STATE ─────────────────────────────────── */
  const CartState = {
    items: [],
    total: 0,
    count: 0,

    async fetch() {
      const res = await fetch('/cart.js');
      const data = await res.json();
      this.items = data.items;
      this.total = data.total_price;
      this.count = data.item_count;
      return data;
    },

    async add(variantId, qty = 1) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      await this.fetch();
      return res.json();
    },

    async update(line, qty) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: qty })
      });
      return this.fetch();
    }
  };

  /* ── FORMAT MONEY ───────────────────────────────── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  /* ── CART DRAWER ────────────────────────────────── */
  const cartOverlay  = document.getElementById('CartOverlay');
  const cartDrawer   = document.getElementById('CartDrawer');
  const cartToggle   = document.getElementById('CartToggle');
  const cartClose    = document.getElementById('CartClose');
  const cartCount    = document.getElementById('CartCount');
  const cartEmpty    = document.getElementById('CartEmpty');
  const cartItems    = document.getElementById('CartItems');
  const cartFooter   = document.getElementById('CartFooter');
  const cartSubtotal = document.getElementById('CartSubtotal');
  const cartContinue = document.getElementById('CartContinue');

  function openCart()  {
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    refreshCartDrawer();
  }
  function closeCart() {
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
  }

  if (cartToggle)   cartToggle.addEventListener('click', openCart);
  if (cartClose)    cartClose.addEventListener('click', closeCart);
  if (cartOverlay)  cartOverlay.addEventListener('click', closeCart);
  if (cartContinue) cartContinue.addEventListener('click', () => { closeCart(); window.location.href = '/collections/watch-cuff'; });

  const cartContinueShopping = document.getElementById('CartContinueShopping');
  if (cartContinueShopping) cartContinueShopping.addEventListener('click', closeCart);

  async function refreshCartDrawer() {
    const data = await CartState.fetch();
    updateCartCount(data.item_count);

    if (data.item_count === 0) {
      cartEmpty.style.display  = 'flex';
      cartItems.style.display  = 'none';
      cartFooter.style.display = 'none';
    } else {
      cartEmpty.style.display  = 'none';
      cartItems.style.display  = 'flex';
      cartFooter.style.display = 'flex';
      cartSubtotal.textContent = formatMoney(data.total_price);
      renderCartItems(data.items);
    }
  }

  function renderCartItems(items) {
    cartItems.innerHTML = items.map((item, index) => `
      <div class="cart-item" data-line="${index + 1}">
        <div class="cart-item-image">
          ${item.image ? `<img src="${item.image}" alt="${item.title}" width="80" height="106">` : ''}
        </div>
        <div class="cart-item-details">
          <p class="cart-item-vendor">${item.vendor}</p>
          <p class="cart-item-title">${item.product_title}</p>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item-variant">${item.variant_title}</p>` : ''}
          <div class="cart-item-qty">
            <button class="qty-btn" data-line="${index + 1}" data-qty="${item.quantity - 1}">−</button>
            <span>${item.quantity}</span>
            <button class="qty-btn" data-line="${index + 1}" data-qty="${item.quantity + 1}">+</button>
          </div>
        </div>
        <div class="cart-item-price">
          ${formatMoney(item.final_line_price)}
          <a href="/cart/change?line=${index + 1}&quantity=0" class="cart-item-remove">Remove</a>
        </div>
      </div>
    `).join('');

    // Qty buttons
    cartItems.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', async () => {
        const line = parseInt(btn.dataset.line);
        const qty  = parseInt(btn.dataset.qty);
        await CartState.update(line, qty < 0 ? 0 : qty);
        refreshCartDrawer();
      });
    });
  }

  function updateCartCount(count) {
    if (cartCount) cartCount.textContent = count;
  }

  /* ── QUICK ADD ──────────────────────────────────── */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.product-quick-add');
    if (!btn) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) {
      // Has multiple variants — go to product page
      const productId = btn.dataset.productId;
      window.location.href = `/products/${productId}`;
      return;
    }

    const originalText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    try {
      await CartState.add(variantId);
      btn.textContent = 'Added ✓';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
      openCart();
    } catch (err) {
      btn.textContent = 'Error';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    }
  });

  /* ── ADD TO CART (PRODUCT PAGE) ─────────────────── */
  const productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const variantId = document.getElementById('VariantId').value;
      const atcBtn = document.getElementById('AddToCart');

      if (!variantId) return;

      atcBtn.textContent = 'Adding…';
      atcBtn.disabled = true;

      try {
        await CartState.add(variantId);
        atcBtn.textContent = 'Added to Bag ✓';
        setTimeout(() => {
          atcBtn.innerHTML = `Add to Bag — <span id="AddToCartPrice">${document.getElementById('AddToCartPrice').textContent}</span>`;
          atcBtn.disabled = false;
        }, 1500);
        openCart();
      } catch {
        atcBtn.textContent = 'Try Again';
        atcBtn.disabled = false;
      }
    });

    // Variant switching
    productForm.querySelectorAll('.option-swatch input').forEach(input => {
      input.addEventListener('change', () => {
        // Update selected state
        const optionGroup = input.closest('.product-option__values');
        optionGroup.querySelectorAll('.option-swatch').forEach(s => s.classList.remove('selected'));
        input.closest('.option-swatch').classList.add('selected');

        // Collect all selected options
        const selected = [];
        document.querySelectorAll('.product-option').forEach(opt => {
          const checked = opt.querySelector('input:checked');
          if (checked) selected.push(checked.value);
        });

        // Match variant via product JSON
        const productData = window.__perdiemProduct;
        if (!productData) return;

        const match = productData.variants.find(v =>
          v.options.every((o, i) => o === selected[i])
        );

        if (match) {
          document.getElementById('VariantId').value = match.id;
          const priceEl = document.getElementById('ProductPrice');
          const atcPrice = document.getElementById('AddToCartPrice');
          if (priceEl) priceEl.textContent = formatMoney(match.price);
          if (atcPrice) atcPrice.textContent = formatMoney(match.price);

          const atcBtn = document.getElementById('AddToCart');
          if (atcBtn) {
            atcBtn.disabled = !match.available;
            if (!match.available) atcBtn.textContent = 'Sold Out';
          }
        }
      });
    });
  }

  /* ── PRODUCT GALLERY ────────────────────────────── */
  const galleryMain   = document.querySelector('.product-gallery__main');
  const galleryThumbs = document.querySelector('.product-gallery__thumbs');

  if (galleryMain && galleryThumbs) {
    galleryThumbs.querySelectorAll('.gallery-thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        const idx = thumb.dataset.index;

        galleryThumbs.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');

        galleryMain.querySelectorAll('.product-gallery__slide').forEach(s => s.classList.remove('active'));
        const target = galleryMain.querySelector(`[data-index="${idx}"]`);
        if (target) target.classList.add('active');
      });
    });
  }

  /* ── ACCORDIONS ─────────────────────────────────── */
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const body    = trigger.nextElementSibling;
      const isOpen  = body.classList.contains('open');
      const expanded = trigger.getAttribute('aria-expanded') === 'true';

      body.classList.toggle('open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!expanded));

      // Rotate chevron
      const icon = trigger.querySelector('svg');
      if (icon) icon.style.transform = isOpen ? '' : 'rotate(180deg)';
    });
  });

  /* ── SEARCH DRAWER ───────────────────────────────── */
  const searchDrawer = document.getElementById('SearchDrawer');
  const searchToggle = document.getElementById('SearchToggle');
  const searchClose  = document.getElementById('SearchClose');
  const searchInput  = document.getElementById('SearchInput');

  if (searchToggle && searchDrawer) {
    searchToggle.addEventListener('click', () => {
      searchDrawer.classList.toggle('open');
      searchDrawer.setAttribute('aria-hidden', searchDrawer.classList.contains('open') ? 'false' : 'true');
      if (searchDrawer.classList.contains('open') && searchInput) {
        setTimeout(() => searchInput.focus(), 300);
      }
    });
  }
  if (searchClose && searchDrawer) {
    searchClose.addEventListener('click', () => {
      searchDrawer.classList.remove('open');
      searchDrawer.setAttribute('aria-hidden', 'true');
    });
  }

  // Close search on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (searchDrawer && searchDrawer.classList.contains('open')) {
        searchDrawer.classList.remove('open');
      }
      if (cartDrawer && cartDrawer.classList.contains('open')) {
        closeCart();
      }
    }
  });

  /* ── ACTIVE NAV ─────────────────────────────────── */
  const currentPath = window.location.pathname;
  document.querySelectorAll('.nav-item').forEach(link => {
    if (link.getAttribute('href') === currentPath) {
      link.classList.add('active');
    }
  });

  /* ── MARQUEE PAUSE ON HOVER ─────────────────────── */
  const marqueeTrack = document.querySelector('.marquee-track');
  if (marqueeTrack) {
    marqueeTrack.addEventListener('mouseenter', () => {
      marqueeTrack.style.animationPlayState = 'paused';
    });
    marqueeTrack.addEventListener('mouseleave', () => {
      marqueeTrack.style.animationPlayState = 'running';
    });
  }

  /* ── SCROLL FADE IN ─────────────────────────────── */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity    = '1';
          entry.target.style.transform  = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('.product-card, .step, .material-tile, .press-item, .cat-card').forEach(el => {
      el.style.opacity   = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(el);
    });
  }

})();

